import { EN_DASH } from "@digitallab/grid-common-frontend-components";
import BooleanIntRender from "./BooleanIntRender";
import { getFieldValue } from "../booking-instruments/helpers";

const BooleanRender = (params) => {
  //  FIXME This seems to be obsolete, as we are already iterating through boolean fields one level above. Investigate why we still need to double-check boolean fields
  const boolean_int_fields = ["isHazardous", "is_hazardous", "should_assisted", "shouldAssisted"];
  const boolean_fields = ["isBookable", "is_bookable", "isVisualized", "is_visualized", "checkInRequired", "check_in_required", ...boolean_int_fields];
  for (const field of boolean_fields) {
    let value = getFieldValue(params?.data, field);
    if (params?.column?.colId === field) {
      if (boolean_int_fields.includes(field)) {
        value = BooleanIntRender(value);
      }
      return <div>{value ?? EN_DASH}</div>;
    }
  }

  return <div>{"BooleanRender.jsx component is not updated!"}</div>;
};

export default BooleanRender;
